export const PRODUCT_TERMS_VERSION = '2026-07-14';

export const TERMS_ACCEPTANCE_REQUIRED_MESSAGE =
  'Accepting the Terms of Service and Privacy Policy is required to sign up.';

export const PRODUCT_WHATSAPP_MARKETING_CONSENT_TEXT =
  'I agree to the Terms of Service and Privacy Policy and receiving marketing offers.';

export const WHATSAPP_MARKETING_STOP_CONFIRMATION =
  'You are opted out of India Case Status marketing messages on WhatsApp. Your case alerts and transactional updates will continue. Reply START if you want marketing messages again later.';
